import * as React from "react";
import styled from "styled-components";

const Wrap = styled.span`
	width: 36px;
	height: 36px;
	border-radius: 50%;
	background: #f3f4f6;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 36px;
	color: #4b4f5e;
`;

function Glyph({ name }: { name?: T.Schema.Restaurant.KdsStationIcon }) {
	if (name === "fry") {
		return (
			<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
				<path d="M8 3v6M12 3v6M16 3v6M6 9h12l-1 12H7L6 9z" stroke="currentColor" strokeWidth="1.8" />
			</svg>
		);
	}
	if (name === "grill") {
		return (
			<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
				<path d="M4 8h16M6 8c0 6 2 10 6 10s6-4 6-10M8 4v2M12 4v2M16 4v2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
			</svg>
		);
	}
	if (name === "pasta") {
		return (
			<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
				<path d="M4 10h16c0 6-3 10-8 10S4 16 4 10zM8 10c0-3 1-5 4-5s4 2 4 5" stroke="currentColor" strokeWidth="1.8" />
			</svg>
		);
	}
	if (name === "dessert") {
		return (
			<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
				<path d="M12 3l2 4h4l-3 3 1 5-4-2-4 2 1-5-3-3h4l2-4z" stroke="currentColor" strokeWidth="1.6" />
			</svg>
		);
	}
	return (
		<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
			<path d="M7 3h7l5 5v13H7V3z" stroke="currentColor" strokeWidth="1.8" />
			<path d="M14 3v5h5" stroke="currentColor" strokeWidth="1.8" />
		</svg>
	);
}

export function StationIcon({ name }: { name?: T.Schema.Restaurant.KdsStationIcon }) {
	return (
		<Wrap>
			<Glyph name={name} />
		</Wrap>
	);
}
